document.addEventListener('DOMContentLoaded', function () {
  // ADA修复补丁

  // 1. Radio 键盘切换同步商品变体
  document.addEventListener('change', function (e) {
    const radio = e.target;
    if (!radio.matches('.t4s-form__product .t4s-swatch__radio:checked')) return;

    const label = radio.labels?.[0];
    if (label?.hasAttribute('data-swatch-item') && !label.classList.contains('is--selected')) {
      label.click();
    }
  });

  // 2. 修复 Selleasy(插件!) 键盘加购需要按两次的问题
  let timer;

  document.addEventListener('click', function (e) {
    const btn = e.target.closest?.('button[data-atc-form]');
    if (!btn) return;

    if (!e.isTrusted) return clearTimeout(timer);
    if (e.detail !== 0) return;

    clearTimeout(timer);
    timer = setTimeout(() => {
      if (btn.isConnected && !btn.disabled && btn.getAttribute('aria-disabled') !== 'true') {
        btn.click();
      }
    }, 300);
  }, true);

  // 加购成功则取消补发
  window.jQuery_T4NT?.(document).on('add:cart:success', function () {
    clearTimeout(timer);
    const status = document.getElementById('t4s-atc-status');
    if (!status) return;
    status.textContent = '';
    setTimeout(() => {
      status.textContent = 'Added to cart successfully';
    }, 100);
  });


  // 3. 购物车抽屉出现后键盘焦点的遗失问题 + 异步刷新后焦点从头开始问题
 const $cart = jQuery_T4NT('#t4s-mini_cart');
 const cart = $cart[0];

 if (cart) {
   $cart.attr({
     role: 'dialog',
     'aria-modal': 'true',
     'aria-labelledby': 'cart-drawer-title'
   });

   // 打开购物车，焦点进入关闭按钮
   let opened = false;
   const isOpen = () => $cart.attr('aria-hidden') === 'false';

   new MutationObserver(() => {
    if (jQuery_T4NT('.xl-gift-popup.active').length || jQuery_T4NT('.t4s-modal.t4s-modal--is-active').length) return;
    if (isOpen() && !opened) $cart.find('[data-drawer-close]').trigger('focus');
     opened = isOpen();
   }).observe(cart, { attributes: true, attributeFilter: ['aria-hidden', 'class'] });

   // Tab / Shift + Tab 在购物车内循环
   jQuery_T4NT(document).on('keydown', function (e) {
     if (e.key !== 'Tab' || !isOpen() || jQuery_T4NT('.xl-gift-popup.active').length || jQuery_T4NT('.t4s-modal.t4s-modal--is-active').length) return;
     const $items = $cart.find('a[href], button:not(:disabled), input:not(:disabled), select:not(:disabled), textarea:not(:disabled), [tabindex]:not([tabindex="-1"])')
       .filter(':visible')
       .filter(function () {
         return !jQuery_T4NT(this).closest('[aria-hidden="true"], [inert]').length;
       });

     const first = $items[0], last = $items[$items.length - 1];
     if (!first) return;

     if (e.shiftKey && (document.activeElement === first || !cart.contains(document.activeElement))) {
       e.preventDefault();
       last.focus();
     } else if (!e.shiftKey && (document.activeElement === last || !cart.contains(document.activeElement))) {
       e.preventDefault();
       first.focus();
     }
   });
 }

//  关闭购物车回到原点
jQuery_T4NT(document).on('click', '.t4s-drawer__close', function () {
  setTimeout(function () {
    jQuery_T4NT('.t4s-site-nav__cart a').first().trigger('focus');
  }, 100); 
});

 
 // 无障碍：购物车数量更新后恢复焦点
 const $miniCart = jQuery_T4NT('#t4s-mini_cart');
 let qtyFocus = null;

 $miniCart.on('click change', '[data-increase-qty], [data-decrease-qty], [data-action-change]', function () {
   const $item = jQuery_T4NT(this).closest('[data-cart-item]');
   const el = $item.find(':focus')[0] || this;

   qtyFocus = {
     index: $miniCart.find('[data-cart-item]').index($item),
     selector: el.hasAttribute('data-increase-qty') ? '[data-increase-qty]' :
               el.hasAttribute('data-decrease-qty') ? '[data-decrease-qty]' : '[data-action-change]'
   };
 });

 jQuery_T4NT(document).on('cart:updated', function () {
   if (!qtyFocus || $miniCart.attr('aria-hidden') !== 'false') return;

   const { index, selector } = qtyFocus;
   qtyFocus = null;

   requestAnimationFrame(() => {
     $miniCart.find('[data-cart-item]').eq(index).find(selector).trigger('focus');
   });
 });


 
  // 4. 无障碍：一级菜单 Enter / Space 展开，Esc 关闭
const $nav = jQuery_T4NT('.t4s-nav__ul');

$nav.on('click', '.ae-menu-trigger', function () {
  const $btn = jQuery_T4NT(this);
  const $item = $btn.closest('li.has--children');
  const open = $btn.attr('aria-expanded') !== 'true';

  $item.toggleClass('is-action__hover', open);
  $btn.attr('aria-expanded', String(open));
});

// Esc 关闭并返回一级菜单
$nav.on('keydown', 'li.has--children', function (e) {
  if (e.key !== 'Escape') return;

  e.preventDefault();
  jQuery_T4NT(this).removeClass('is-action__hover')
    .children('.ae-menu-trigger')
    .attr('aria-expanded', 'false')
    .trigger('focus');
});

// Tab 离开菜单时重置状态
$nav.on('focusout', 'li.has--children', function (e) {
  if (this.contains(e.relatedTarget)) return;

  jQuery_T4NT(this).removeClass('is-action__hover')
    .children('.ae-menu-trigger')
    .attr('aria-expanded', 'false');
});

 // 5. 无障碍：移动端菜单焦点管理
 const $menu = jQuery_T4NT('#t4s-menu-drawer');
 const $menuBtn = jQuery_T4NT('[data-menu-drawer]');

 if ($menu.length) {
   let opened = false;
   const isOpen = () => $menu.attr('aria-hidden') === 'false';

   $menu.attr({ role: 'dialog', 'aria-label': 'Navigation menu' });

   // 打开后聚焦关闭按钮，关闭后返回菜单按钮
   new MutationObserver(() => {
     const open = isOpen();
     if (open === opened) return;

     opened = open;
     $menu.attr('aria-modal', String(open));
     $menuBtn.attr('aria-expanded', String(open));

     if (open) {
       $menu.find('[data-drawer-close]:visible').first().trigger('focus');
     } else {
       $menuBtn.first().trigger('focus');
     }
   }).observe($menu[0], {
     attributes: true,
     attributeFilter: ['aria-hidden', 'class']
   });

   // Tab / Shift + Tab 只在菜单内部循环
   jQuery_T4NT(document).on('keydown', function (e) {
     if (!opened || e.key !== 'Tab') return;

     const $items = $menu.find(
       'a[href], button:not(:disabled), input:not(:disabled), select:not(:disabled), [tabindex]:not([tabindex="-1"])'
     ).filter(':visible').filter(function () {
       return !jQuery_T4NT(this).closest('[inert], [aria-hidden="true"]').length;
     });

     const first = $items[0], last = $items[$items.length - 1];
     if (!first) return;

     if (e.shiftKey && (document.activeElement === first || !$menu[0].contains(document.activeElement))) {
       e.preventDefault();
       last.focus();
     } else if (!e.shiftKey && (document.activeElement === last || !$menu[0].contains(document.activeElement))) {
       e.preventDefault();
       first.focus();
     }
   });
 }


  // 6. 无障碍：商品卡片颜色色块键盘访问
 function initColorAccessibility(root = document) {
   jQuery_T4NT(root).find('.t4s-pr-color__item')
     .addBack('.t4s-pr-color__item').each(function () {
       const $item = jQuery_T4NT(this);
       const color = $item.find('.t4s-pr-color__name').text().trim();
       if (!color) return;

       $item.attr({
         role: 'img',
         tabindex: '0',
         'aria-label': color + ' color'
       });
     });
 }

 initColorAccessibility();

 // T4S 动态生成色块后重新补充属性
 new MutationObserver(function (mutations) {
   mutations.forEach(function (mutation) {
     mutation.addedNodes.forEach(function (node) {
       if (node.nodeType === 1) initColorAccessibility(node);
     });
   });
 }).observe(document.body, { childList: true, subtree: true });


  // 7. Account Drawer 无障碍焦点管理
const $drawer = jQuery_T4NT('#t4s-login-sidebar');
if ($drawer.length) {
  let trigger = null;
  // 打开账户面板
  jQuery_T4NT(document).on(
    'click',
    '[data-drawer-options*="t4s-login-sidebar"], [data-login-sidebar-trigger]',
    function () {
      trigger = this;

      setTimeout(function () {
        $drawer.find('input, button, a')
          .filter(':visible')
          .first()
          .trigger('focus');
      }, 100);
    }
  );
  // ESC 关闭
  jQuery_T4NT(document).on('keydown', function (e) {
    if (e.key === 'Escape' && $drawer.attr('aria-hidden') === 'false') {
      $drawer.find('[data-drawer-close]').trigger('click');
    }
  });
  // 关闭后恢复焦点
  $drawer.on('click', '[data-drawer-close]', function () {
    if (trigger) {
      jQuery_T4NT(trigger).trigger('focus');
    }
  });
}


  // 8. 搜索框ADA
  jQuery_T4NT(document).on("click", "[data-drawer-close]", function () {
  const $drawer = jQuery_T4NT(this).closest(".t4s-drawer");

  if ($drawer.find("[data-input-search]").length) {
    setTimeout(function () {
      jQuery_T4NT('[aria-label="Search"]').first().trigger("focus");
    }, 100);
  }
});
jQuery_T4NT(document).on("keydown", function (e) {
  if (e.key === "Escape" && $(`#t4s-search-hidden[aria-hidden=false]`).length > 0) {
    setTimeout(function () {
      jQuery_T4NT('[aria-label="Search"]').first().trigger("focus");
    }, 100);
  }
});

// 9.货币ADA
jQuery_T4NT("button.t4s-currency-item").on("click keydown", function (e) {
  if (e.type === 'keydown' && e.key === 'Enter'){
    jQuery_T4NT('button[data-dropdown-open][data-id*="dropdown_currencies"]').trigger("focus");
  }
});

// 10.国家切换ADA
let gtReady = false;
function initGTranslateA11y() {
  const $gt = jQuery_T4NT(".gt_switcher");
  if (!$gt.length) return;
  // 防止重复执行
  if (gtReady) return;
  gtReady = true;
  const $trigger = $gt.find(".gt_selected a");

  // 旗帜图片不参与朗读
  $gt.find("img").attr("alt", "");

  // 选择语言后恢复焦点
  $gt.on("click", ".gt_option a", function () {
    setTimeout(function () {
      $trigger.trigger("focus");
    }, 300);
  });
}
// 插件异步加载，监听 DOM
const observer = new MutationObserver(function () {
  if (jQuery_T4NT(".gt_switcher").length) {
    initGTranslateA11y();
  }
});
observer.observe(document.body, {
  childList: true,
  subtree: true,
});
// 页面已经存在时执行
initGTranslateA11y();


// 11. 商品页
// 图片放大灯箱：关闭后恢复焦点
if (document.body.classList.contains('template-product')) {
  function restoreFocus() {
    setTimeout(function () {
      jQuery_T4NT('.t4s-pr__pswp-btn').first().trigger('focus');
    }, 100);
  }
  // ESC 关闭
  jQuery_T4NT(document).on('keydown', function (e) {
    if (e.key === 'Escape' && jQuery_T4NT('.pswp.pswp--open').length) {
      restoreFocus();
    }
  });
  // 点击关闭按钮
  document.addEventListener('click', function (e) {
    const closeBtn = e.target.closest('.pswp__button--close');
    if (!closeBtn) return;
    setTimeout(function () {
      const trigger = document.querySelector('.t4s-pr__pswp-btn');
      if (trigger) {
        trigger.focus({ preventScroll: true });
      }
    }, 100);
  }, true);


  // Tab 展开/关闭
  jQuery_T4NT(document).on('click', '.t4s-tab__title', function () {
    const $btn = jQuery_T4NT(this);
    const expanded = $btn.attr('aria-expanded') === 'true';
    $btn.attr('aria-expanded', String(!expanded));
  });

  // Bundle 加购插件：支持键盘操作
  const addBtn = '.ppcse-tot-btn-div.lb-upsell-tot-btn';
const img = '.ppcse-img-lt-img';
const modal = '.ppcse-modal-wrap';
const overlay = '.ppcse-modal-bg';
const selectors = addBtn + ', ' + img;
const focusable = 'button:not(:disabled), a[href], input:not(:disabled), select:not(:disabled), textarea:not(:disabled), [tabindex="0"]';
let lastTrigger = null;

// 初始化：添加属性与点击事件
function init(root) {
  console.log(111)
  const $root = $(root);
  const $items = $root.filter(selectors).add($root.find(selectors));
  
  $items.attr({ role: 'button', tabindex: '0' });

  $items.filter(img).off('click.bundleA11y').on('click.bundleA11y', function () {
    lastTrigger = this;
    setTimeout(openModal, 150);
  });
}

const isOpen = () => {
  const el = $(modal)[0];
  return !!el && getComputedStyle(el).display !== 'none' && !!(el.offsetWidth || el.offsetHeight);
};

const getFocusable = () => $(modal).find(focusable).filter(':visible');

// 打开弹窗并聚焦
function openModal() {
  if (!isOpen()) return;
  const $modal = $(modal);
  $modal.attr({ role: 'dialog', 'aria-modal': 'true', tabindex: '-1' });
  (getFocusable()[0] || $modal[0]).focus();
}

// 关闭弹窗并恢复焦点
function closeModal() {
  const $close = $(modal).find('.ppcse-close span').first();
  
  if ($close.length) {
    $close.trigger('click');
  } else {
    $(modal).hide();
    $(overlay).hide();
  }

  setTimeout(() => {
    if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
  }, 200);
}

// 动态渲染监听
init(document);
new MutationObserver(mutations => {
  mutations.forEach(m => m.addedNodes.forEach(node => {
   if (node.nodeType !== 1) return;
      if (
        node.matches(selectors) ||
        node.querySelector(selectors)
      ) {
        init(node);
      }
  }));
}).observe(document.body, { childList: true, subtree: true });

// 键盘交互：Enter / Space 激活
$(document).on('keydown.bundleA11y', selectors, function (e) {
  if (e.key === 'Enter' && !e.repeat) {
    e.preventDefault();
    this.click();
  } else if (e.key === ' ') {
    e.preventDefault();
  }
}).on('keyup.bundleA11y', selectors, function (e) {
  if (e.key === ' ') {
    e.preventDefault();
    this.click();
  }
});

// 弹窗关闭按钮点击：恢复焦点
$(document).on('click.bundleA11y', modal + ' .ppcse-close', function () {
  setTimeout(() => {
    if (!isOpen() && lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
  }, 200);
});

// 全局键盘：Esc 关闭 & Tab 焦点循环
$(document).on('keydown.bundleA11y', function (e) {
  if (!isOpen()) return;

  if (e.key === 'Escape') {
    e.preventDefault();
    closeModal();
    return;
  }

  if (e.key === 'Tab') {
    const $items = getFocusable();
    const $modal = $(modal);

    if (!$items.length) {
      e.preventDefault();
      $modal.trigger('focus');
      return;
    }

    const first = $items[0], last = $items[$items.length - 1];
    const active = document.activeElement;

    if (e.shiftKey && (active === first || !$modal[0].contains(active))) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && (active === last || !$modal[0].contains(active))) {
      e.preventDefault();
      first.focus();
    }
  }
});

}


// 12. 购物车弹窗：关闭后恢复到原来的编辑按钮
let editTrigger = null;

jQuery_T4NT(document).on('click', '.t4s-mini_cart__edit', function () {
  editTrigger = this;
});

jQuery_T4NT(document).on('click', '.t4s-modal-close', function () {
  if (!editTrigger) return;
  setTimeout(function () {
    if (document.contains(editTrigger)) editTrigger.focus();
    editTrigger = null;
  }, 100);
});

// Tab 键内循环
jQuery_T4NT(document).on('keydown', function (e) {
  if (e.key !== 'Tab') return;
  const $modal = jQuery_T4NT('.t4s-modal--is-active .t4s-modal__inner');
  if (!$modal.length) return;

  const $items = $modal.find('button:not(:disabled), a[href], input:not(:disabled), select:not(:disabled), textarea:not(:disabled), [tabindex]:not([tabindex="-1"])').filter(':visible');
  
  if (!$items.length) return;
  const first = $items[0], last = $items[$items.length - 1];
  if (e.shiftKey && document.activeElement === first) {
    e.preventDefault(); last.focus();
  } else if (!e.shiftKey && document.activeElement === last) {
    e.preventDefault(); first.focus();
  }
});

// 13. 购物车 / Modal 关闭后恢复焦点
const cartOrigin = '.t4s-site-nav__cart a';
jQuery_T4NT(document).on('keydown', function (e) {
  if (e.type === 'keydown' && e.key !== 'Escape') return;
    if (jQuery_T4NT('.t4s-drawer[aria-hidden="false"], .t4s-modal.t4s-modal--is-active').length > 0) {
        setTimeout(function () {jQuery_T4NT(cartOrigin).first().trigger('focus');  }, 200);
    }
});

  // End ADA修复补丁

});